module.exports = __webpack_public_path__ + "3506201220bbfefb52296b87a16cb491.png";